module.exports = class PopUpWindow
  constructor: (url, windowName = 'Trello', width = 450, height = 700) ->
    @url = url
    @windowName = windowName
    @width = width
    @height = height

  open: ->
    left = window.screenX + (window.innerWidth - @width) / 2
    top = window.screenY + (window.innerHeight - @height) / 2

    @popup = window.open(
      @url,
      @windowName,
      "width=#{@width},height=#{@height},top=#{top},left=#{left}"
    )



// WEBPACK FOOTER //
// ./app/scripts/views/lib/pop-up-window.coffee